/* FirebaseUI sign-in flow (Google + email/password), shown in a modal.
   Kept separate from cloud.ts so vrstore.js doesn't bundle the UI. */
import firebase from 'firebase/compat/app';
import * as firebaseui from 'firebaseui';

let ui: firebaseui.auth.AuthUI | null = null;

export function showSignIn(container: HTMLElement, onDone: () => void): void {
  if (!ui) ui = new firebaseui.auth.AuthUI(firebase.auth());
  ui.start(container, {
    signInOptions: [
      firebase.auth.GoogleAuthProvider.PROVIDER_ID,
      firebase.auth.EmailAuthProvider.PROVIDER_ID,
    ],
    signInFlow: 'popup',
    callbacks: {
      signInSuccessWithAuthResult: () => { onDone(); return false; },   // no redirect
    },
  });
}
